import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import { Stack, LinearProgress } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteSweepIcon from "@mui/icons-material/DeleteSweep";
import { useDeleteListMutation } from "../list-manager/api";
import { BeatLoader } from "react-spinners";
import { useQueryClient } from "@tanstack/react-query";
import ArchiveIcon from '@mui/icons-material/Archive';
import ErrorHandler from "../list-manager/error-handling/ErrorHandler";
import { AxiosError } from "axios";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

type DeleteListModalProps = {
  list: List | undefined;
};

export default function DeleteListModal({ list }: DeleteListModalProps) {
  const queryClient = useQueryClient();
  const [open, setOpen] = React.useState(false);
  const { mutate, isPending, isSuccess, reset: resetMutation, error } = useDeleteListMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["contact-lists"] });
    },
  });

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    resetMutation();
  };

  return (
    <React.Fragment>
      <Button
        onClick={handleClickOpen}
        // sx={{ background: "#fff" }}
        variant="contained"
        color="error"
        startIcon={<ArchiveIcon />}
      >
        Archive List
      </Button>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Archive List
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Stack width={400} padding={3} alignItems="center">
            {isPending ? (
              <LinearProgress style={{width: "100%"}} />
            ) : isSuccess ? (
              <Typography style={{textAlign: "center", fontSize: 14, fontWeight: "bold"}}>{list?.name} has been Archived.</Typography>
            ) : error ?
            <ErrorHandler error={error as AxiosError}/>
            :
            (
              <Typography style={{textAlign: "center", fontSize: 14, fontWeight: "bold"}}>
                Are you sure you want to Archive {list?.name}?
                The List will no longer be available for Dialing
              </Typography>
            )}
          </Stack>
        </DialogContent>
        {isSuccess ? (
          <DialogActions>
            <Button onClick={handleClose}>Close</Button>
          </DialogActions>
        ) : (
          <DialogActions>
            <Button onClick={handleClose} disabled={isPending}>
              Cancel
            </Button>
            <Button
              autoFocus
              onClick={() => mutate({ list_id: list?.id || "" })}
              disabled={isPending}
              color="error"
            >
              Confirm Archive
            </Button>
          </DialogActions>
        )}
      </BootstrapDialog>
    </React.Fragment>
  );
}
